import React, {useMemo} from 'react';
import clsx from 'clsx';
import {SelectField} from '@netx/core-components/SelectField';
import {useSavedCarts} from '@netx/core-cart-saved';
import {composeClasses, styled, WithClasses} from '@netx/core-components/Theme';
import {CommonRuleEditorProps} from '../../../types';
import {
	cartRuleEditorClasses,
	getCartRuleEditorUtilityClass,
	CartRuleEditorClasses,
	CART_RULE_EDITOR_CLASS_NAME,
} from './cartRuleEditorClasses';

export type CartRuleEditorOwnerState = WithClasses<CartRuleEditorClasses, {}>;

const useUtilityClasses = (ownerState: CartRuleEditorOwnerState) => {
	const {classes} = ownerState;
	const slots = {
		root: ['root'],
	};
	return composeClasses(slots, getCartRuleEditorUtilityClass, classes);
};

const CartRuleEditorRoot = styled('div', {
	name: CART_RULE_EDITOR_CLASS_NAME,
	slot: 'Root',
})(({theme}) => ({
	display: 'flex',
	flex: '1 1 auto',
}));

type OptionParams = {
	labels: {
		[k: number]: string;
	};
	ids: number[];
};

export type CartRuleEditorProps = WithClasses<
	CartRuleEditorClasses,
	CommonRuleEditorProps & {}
>;

const CartRuleEditorInner = ({
	classes: _classes,
	className,
	elementValue1,
	onSubType1Change,
}: CartRuleEditorProps) => {
	const ownerState: CartRuleEditorOwnerState = {
		classes: _classes,
		className,
	};

	const classes = useUtilityClasses(ownerState);

	const {savedCarts} = useSavedCarts();

	const options = useMemo(() => {
		return savedCarts.reduce<OptionParams>(
			(accum, savedCart, index) => {
				return {
					labels: {
						...accum.labels,
						[savedCart.id]: savedCart.title,
					},
					ids: [...accum.ids, savedCart.id],
				};
			},
			{labels: {}, ids: []},
		);
	}, [savedCarts]);

	return (
		<CartRuleEditorRoot className={clsx(classes.root, className)}>
			<SelectField<number, false, true, false>
				data-testid="cart-rule-value-1"
				disableClearable
				options={options.ids}
				label="Saved Cart"
				name={'rule-value-1'}
				value={(elementValue1 as number) || undefined}
				getOptionLabel={(option) => options.labels[option]}
				onChange={(event, value) => onSubType1Change(value)}
			/>
		</CartRuleEditorRoot>
	);
};

export const CartRuleEditorPrimitive = CartRuleEditorInner;

export const CartRuleEditor = CartRuleEditorPrimitive;

export default CartRuleEditor;
